import getConfig from 'next/config'
const { publicRuntimeConfig, serverRuntimeConfig } = getConfig()

export const getLegalDocByType = async (type) => {
  try {
    const apiUrl = `${publicRuntimeConfig.legalApiBaseUrl}/api/v1/legalDoc/${type}`
    const response = await fetch(apiUrl)
    if (!response.ok) {
      throw `getLegalDocByType failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getLegalDocs = async (legalTypes) => {
  try {
    const query = new URLSearchParams()
    legalTypes?.forEach((legalType) => {
      query.append('legalTypes', legalType)
    })
    const apiUrl = `${publicRuntimeConfig.legalApiBaseUrl}/api/v1/legalDocs?${query.toString()}`
    const response = await fetch(apiUrl)
    if (!response.ok) {
      throw `getLegalDocs failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getLegalDocsServer = async (legalTypes) => {
  try {
    const query = new URLSearchParams()
    legalTypes?.forEach((legalType) => {
      query.append('legalTypes', legalType)
    })
    const apiUrl = `${serverRuntimeConfig.legalApiBaseUrl}/api/v1/legalDocs?${query.toString()}`
    const response = await fetch(apiUrl)
    if (!response.ok) {
      throw `getLegalDocs failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getAllAcceptedLegalsServer = async (cookie) => {
  try {
    const apiUrl = `${serverRuntimeConfig.legalApiBaseUrl}/api/v1/legalAcceptance/allAcceptedByUser`
    console.log('GET getAllAcceptedLegalsServer url:', apiUrl)
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: cookie && { cookie }
    })
    if (!response.ok) {
      throw `getAllAcceptedLegalsServer failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getAllUnacceptedLegals = async (cookie) => {
  try {
    const apiUrl = `${publicRuntimeConfig.legalApiBaseUrl}/api/v1/legalAcceptance/allUnaccepted`
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: cookie && { cookie }
    })

    if (!response.ok) {
      throw `getAllUnacceptedLegals failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getLegalDocsVersion = async (legalType) => {
  try {
    const apiUrl = `${serverRuntimeConfig.legalApiBaseUrl}/api/v1/legalDocs/version?legalTypes=${legalType}`
    const response = await fetch(apiUrl)
    if (!response.ok) {
      throw `getLegalDocs failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}
